module.exports = __webpack_public_path__ + "img/app1.c89b2abf.png";